import React, { Suspense, lazy, useState } from "react";
import { UserChildsUIProvider } from "./UserChildsUIContext";
import { UserChildsTable } from "./UserChildsTable";
import { useFormik } from "formik";
import * as Yup from "yup";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  register,
  registerSystemUser,
} from "../../../modules/Auth/_redux/authCrud";
import * as actions from "./_redux/system-user-childs/systemUserChildsActions";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { SystemUserUiSettings } from "../pages/_redux/system-user-childs/SystemUserUiSettings";
const initialValues = {
  fullname: "",
  email: "",
  username: "",
  password: "",
  taxId: "",
  changepassword: "",
  acceptTerms: false,
};

export function UserChildsPage(props) {
  const user = useSelector((state) => state.auth.user, shallowEqual);

  const customersUIEvents = { openFetchCustomersDialog: () => {} };

  var systemUserUiSettings = new SystemUserUiSettings();
  systemUserUiSettings.Set(user);

  let headline = "Manager accounts";
  let systemUserChildType = "";

  if (
    systemUserUiSettings.userType.systemUserType == systemUserUiSettings.ADMIN
  ) {
    headline = "Managers";
    systemUserChildType = "Manager";
  }

  if (
    systemUserUiSettings.userType.systemUserType ==
    systemUserUiSettings.SUPER_ADMIN
  ) {
    headline = "Admins";
    systemUserChildType = "Admin";
  }

  const dispatch = useDispatch();
  const [showCustomerCreateForm, setshowCustomerCreateForm] = useState(false);
  const [showAdminCreateForm, setshowAdminCreateForm] = useState(false);

  const onClick = () => setshowCustomerCreateForm(!showCustomerCreateForm);

  const onAdminChildClick = () => setshowAdminCreateForm(!showAdminCreateForm);

  const { intl } = props;
  const [loading, setLoading] = useState(false);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const CustomerRegistrationSchema = Yup.object().shape({
    fullname: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(""),
    username: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(""),
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(""),
    taxId: Yup.string()
      .min(9, "Minimum 3 symbols")
      .max(10, "Maximum 50 symbols")
      .required(""),
    changepassword: Yup.string()
      .required("")
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Password and Confirm Password didn't match"
        ),
      }),
  });

  const AdminRegistrationSchema = Yup.object().shape({
    fullname: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(""),
    username: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(""),
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(""),
    changepassword: Yup.string()
      .required("")
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Password and Confirm Password didn't match"
        ),
      }),
  });
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formikAdmin = useFormik({
    initialValues,
    validationSchema: AdminRegistrationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setSubmitting(true);
      enableLoading();

      registerSystemUser(values.fullname, values.username, values.password)
        .then(({ data: { accessToken } }) => {
          //   props.register(accessToken);
          setStatus("User created");
          dispatch(actions.fetch(undefined));
          setSubmitting(false);
          disableLoading();
        })
        .catch((error) => {
          setSubmitting(false);
          setStatus(error.response.data);

          disableLoading();
        });
    },
  });
  const formik = useFormik({
    initialValues,
    validationSchema: CustomerRegistrationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setSubmitting(true);
      // enableLoading();
      console.log(values);
      register(
        values.email,
        values.fullname,
        values.username,
        values.password,
        values.taxId
      )
        .then(({ data: { accessToken } }) => {
          //   props.register(accessToken);
          setStatus("User created");
          dispatch(actions.fetch(undefined));
          setSubmitting(false);
        })
        .catch((error) => {
          setSubmitting(false);
          setStatus(error.response.data.error);
          // disableLoading();
        });
    },
  });

  if (
    systemUserUiSettings.userType.systemUserType == systemUserUiSettings.MANAGER
  ) {
    return (
      <Card>
        <CardHeader title={headline}>
          <CardHeaderToolbar>
            <button type="button" className="btn btn-primary" onClick={onClick}>
              New Customer
            </button>
          </CardHeaderToolbar>
        </CardHeader>

        <CardBody>
          {showCustomerCreateForm && (
            <form onSubmit={formik.handleSubmit}>
              {/* begin: Alert */}
              {formik.status && (
                <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                  <div className="alert-text font-weight-bold">
                    {formik.status}
                  </div>
                </div>
              )}
              {/* end: Alert */}

              <div className="form-group fv-plugins-icon-container">
                <input
                  placeholder="Full name"
                  type="text"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "fullname"
                  )}`}
                  name="fullname"
                  {...formik.getFieldProps("fullname")}
                />
                {formik.touched.fullname && formik.errors.fullname ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.fullname}
                    </div>
                  </div>
                ) : null}
              </div>
              {/* end: Fullname */}

              {/* begin: Username */}
              <div className="form-group fv-plugins-icon-container">
                <input
                  placeholder="User name"
                  type="text"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "username"
                  )}`}
                  name="username"
                  {...formik.getFieldProps("username")}
                />
                {formik.touched.username && formik.errors.username ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.username}
                    </div>
                  </div>
                ) : null}
              </div>
              {/* end: Username */}

              {/* begin: taxId */}
              <div className="form-group fv-plugins-icon-container">
                <input
                  placeholder="tax Id"
                  type="number"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "taxId"
                  )}`}
                  name="taxId"
                  {...formik.getFieldProps("taxId")}
                />
                {formik.touched.username && formik.errors.username ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.username}
                    </div>
                  </div>
                ) : null}
              </div>
              {/* end: taxId */}

              {/* begin: Password */}
              <div className="form-group fv-plugins-icon-container">
                <input
                  placeholder="Password"
                  type="password"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "password"
                  )}`}
                  name="password"
                  {...formik.getFieldProps("password")}
                />
                {formik.touched.password && formik.errors.password ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.password}
                    </div>
                  </div>
                ) : null}
              </div>
              {/* end: Password */}

              {/* begin: Confirm Password */}
              <div className="form-group fv-plugins-icon-container">
                <input
                  placeholder="Confirm Password"
                  type="password"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "changepassword"
                  )}`}
                  name="changepassword"
                  {...formik.getFieldProps("changepassword")}
                />
                {formik.touched.changepassword &&
                formik.errors.changepassword ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.changepassword}
                    </div>
                  </div>
                ) : null}
              </div>

              {/* end: Confirm Password */}

              <div className="form-group d-flex flex-wrap flex-center">
                <button
                  type="submit"
                  disabled={formik.isSubmitting || !formik.isValid}
                  className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                >
                  <span>Submit</span>
                  {loading && (
                    <span className="ml-3 spinner spinner-white"></span>
                  )}
                </button>
              </div>
            </form>
          )}
        </CardBody>

        <CardBody>
          <div className="container">
            <UserChildsUIProvider customersUIEvents={customersUIEvents}>
              <UserChildsTable />{" "}
            </UserChildsUIProvider>
          </div>
        </CardBody>
      </Card>
    );
  } else {
    return (
      <Card>
        <CardHeader title={headline}>
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onAdminChildClick}
            >
              New {systemUserChildType}
            </button>
          </CardHeaderToolbar>
        </CardHeader>

        <CardBody>
          {showAdminCreateForm && (
            <form onSubmit={formikAdmin.handleSubmit}>
              {/* begin: Alert */}
              {formikAdmin.status && (
                <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                  <div className="alert-text font-weight-bold">
                    {formikAdmin.status}
                  </div>
                </div>
              )}
              {/* end: Alert */}

              <div className="form-group fv-plugins-icon-container">
                <input
                  placeholder="Full name"
                  type="text"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "fullname"
                  )}`}
                  name="fullname"
                  {...formikAdmin.getFieldProps("fullname")}
                />
                {formikAdmin.touched.fullname && formik.errors.fullname ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formikAdmin.errors.fullname}
                    </div>
                  </div>
                ) : null}
              </div>
              {/* end: Fullname */}

              {/* begin: Username */}
              <div className="form-group fv-plugins-icon-container">
                <input
                  placeholder="User name"
                  type="text"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "username"
                  )}`}
                  name="username"
                  {...formikAdmin.getFieldProps("username")}
                />
                {formikAdmin.touched.username && formikAdmin.errors.username ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formikAdmin.errors.username}
                    </div>
                  </div>
                ) : null}
              </div>
              {/* end: Username */}

              {/* begin: Password */}
              <div className="form-group fv-plugins-icon-container">
                <input
                  placeholder="Password"
                  type="password"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "password"
                  )}`}
                  name="password"
                  {...formikAdmin.getFieldProps("password")}
                />
                {formikAdmin.touched.password && formik.errors.password ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formikAdmin.errors.password}
                    </div>
                  </div>
                ) : null}
              </div>
              {/* end: Password */}

              {/* begin: Confirm Password */}
              <div className="form-group fv-plugins-icon-container">
                <input
                  placeholder="Confirm Password"
                  type="password"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "changepassword"
                  )}`}
                  name="changepassword"
                  {...formik.getFieldProps("changepassword")}
                />
                {formikAdmin.touched.changepassword &&
                formikAdmin.errors.changepassword ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formikAdmin.errors.changepassword}
                    </div>
                  </div>
                ) : null}
              </div>

              {/* end: Confirm Password */}

              <div className="form-group d-flex flex-wrap flex-center">
                <button
                  type="submit"
                  disabled={formikAdmin.isSubmitting || !formikAdmin.isValid}
                  className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                >
                  <span>Submit</span>
                  {loading && (
                    <span className="ml-3 spinner spinner-white"></span>
                  )}
                </button>
              </div>
            </form>
          )}
        </CardBody>

        <CardBody>
          <div className="container">
            <UserChildsUIProvider customersUIEvents={customersUIEvents}>
              <UserChildsTable />{" "}
            </UserChildsUIProvider>
          </div>
        </CardBody>
      </Card>
    );
  }
}
